import $ from "jquery";

/**
 * When document is loaded
 * trigger the first floorplan accordion if necessary
 */
window.addEventListener("DOMContentLoaded", function() {
  // Trigger first accordion for mobile view (<600px)
  if (window.innerWidth < 600) {
    $(".floorplans-wrapper .js-accordion__block").first().children('.js-accordion-header').trigger('click');
  } else if (window.innerWidth < 790) {
    $(".floorplans-wrapper .js-accordion__block").first().children('.js-accordion-header').trigger('click');
  }
});

$('.js-accordion-header').on('click', function() {
  let _this = $(this);
  let floorplan = _this.parent().attr('data-floorplan');
  let expanded = _this.hasClass('expanded');

  // Collapse the expanded accordion
  $('.expanded').next().fadeOut(300).animate({ opacity: 0 }, 300);
  $('.expanded').removeClass('expanded');

  if (!expanded) {
    // Expand the clicked accordion
    _this.addClass('expanded');
    _this.closest('.js-accordion__block').children('.js-accordion-body').fadeIn(300).animate({ opacity: 1 }, 300);
  }

  /**
   * Trigger corresponding floorplan image
   * based on screen width
   */
  if (typeof floorplan !== 'undefined' && floorplan !== false) {
    if (window.innerWidth > 790) {
      $('.floorplan-image').fadeOut(300).animate({ opacity: 0 }, 300);
      _this.closest('.vc_row').find(`div[data-floorplanimage='${floorplan}']`).fadeIn(300).animate({ opacity: 1 }, 300);
    } else {
      _this.find('.floorplan-image').fadeIn(300).animate({ opacity: 1 }, 300);
    }
  } else {
    _this.toggleClass('expanded');
    _this.closest('.js-accordion__block').children('.js-accordion-body').fadeToggle(300);
  }
});
